module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/doctor/doctor.component.css
// module id = ./src/app/Pages/manage/doctor/doctor.component.css
// module chunks = main